export const POLL_INTERVAL = 20000;
export const POLL_INTERVAL_SUBSCRIPTION = 0;
export const QUERY_VARIABLES = {
  filterBy: {
    trackName: []
  }
};
